// @todo: Migrate to 'Select' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Select} from '@wandb/weave/components/Form/Select';
// @todo: Migrate to 'TextField' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {TextField} from '@wandb/weave/components/Form/TextField';
import React, {type FC, memo, useContext} from 'react';

import {COUNTRY_CODE_NAME_OPTIONS} from '../../../util/countryCode';
import {
  BillingAddressContext,
  BillingAddressContextUpdater,
} from './BillingAddressContext';

const weaveCountryOptions = COUNTRY_CODE_NAME_OPTIONS.map(opt => ({
  value: opt.value,
  label: opt.text,
}));

const BillingAddressInputComp: FC = () => {
  const {line1, country, postalCode} = useContext(BillingAddressContext);

  const {setLine1, setCountry, setPostalCode} = useContext(
    BillingAddressContextUpdater
  );

  const useUSAFormat = country === 'US';

  const selectedCountryOption = weaveCountryOptions.find(
    o => o.value === String(country)
  );

  return (
    <div className="mb-2.5 flex w-full flex-col space-y-3">
      <div className="w-full px-3 py-2">
        <TextField
          value={line1}
          placeholder="Address on card"
          onChange={(value: string) => setLine1(value)}
        />
      </div>
      <div className="flex w-full flex-row gap-x-2">
        <div className="flex-1 px-3 py-2">
          <TextField
            value={postalCode}
            placeholder={useUSAFormat ? 'Zip code' : 'Postal code'}
            onChange={(value: string) => setPostalCode(value)}
          />
        </div>
        <div className="flex-1 px-3 py-2">
          <Select
            value={selectedCountryOption}
            placeholder="Country"
            options={weaveCountryOptions}
            menuPlacement="bottom"
            className="text-left"
            onChange={selected => {
              if (selected?.value) {
                setCountry(selected.value as string);
              }
            }}
          />
        </div>
      </div>
    </div>
  );
};

export const BillingAddressInput = memo(BillingAddressInputComp);
